<script lang="ts">
  import { writable } from 'svelte/store'
  import Modal from 'svelte-simple-modal'

  import AboutModal from './AboutModal.svelte'
  import ForwardButton from './ForwardButton.svelte'
  import ProgressBar from './ProgressBar.svelte'
  import SearchableSelect from './answers/SearchableSelect.svelte'
  import SingleChoice from './answers/SingleChoice.svelte'
  import MultipleChoice from './answers/MultipleChoice.svelte'
  import Number from './answers/Number.svelte'
  import TextArea from './answers/TextArea.svelte'
  import Viz from './answers/Viz.svelte'
  import BackButton from './BackButton.svelte'
  import DataPortrait from './DataPortrait.svelte'
  import HeaderLogos from './HeaderLogos.svelte'

  import { currentQuestion, progressCount, surveyStatus } from '../stores'
  import {
    TYPE_CHECKBOX,
    TYPE_NUMBER,
    TYPE_RADIO,
    TYPE_SELECT,
    TYPE_TEXTAREA,
    TYPE_VIZ,
  } from '../types/question'

  const aboutModal = writable(null)
  const showAboutModal = () => aboutModal.set(AboutModal)
</script>

<Modal
  show={$aboutModal}
  styleContent={{ padding: '1.5rem' }}
  styleCloseButton={{ boxShadow: 'none', background: '#e4e4e4' }}
/>

{#if $surveyStatus.currentQuestionId !== 'end_of_survey' && $surveyStatus.currentQuestionId !== 'start_survey'}
  <div class="portrait-bar">
    <ProgressBar />
    <DataPortrait width={75} />
  </div>
{:else if $surveyStatus.currentQuestionId === 'start_survey'}
  <HeaderLogos />
{/if}

<div class="wrapper">
  <section
    class={$surveyStatus.currentQuestionId === 'start_survey'
      ? 'survey-section survey-section--start'
      : 'survey-section'}
  >
    {#key $progressCount}
      {#if $surveyStatus.currentQuestionId === 'start_survey'}
        <div class="survey-banner" />

        <h1>Scopri quanto la tua mobilità è sostenibile</h1>

        <div class="buttons-bar">
          <ForwardButton />
        </div>
      {:else if $currentQuestion}
        <h2>{$currentQuestion.question}</h2>

        <div class="subtext-wrapper">
          {#if $currentQuestion.subtext}
            <p class="subtext">
              {$currentQuestion.subtext}
            </p>

            {#if $currentQuestion.type === TYPE_CHECKBOX}
              <div class="multiple-choice-trackers">
                {#each Array(3) as _, i}
                  <span
                    style={$surveyStatus.currentUserAnswer.length > i ? 'background: #00fff0' : ''}
                    class="multiple-choice-tracker"
                  />
                {/each}
              </div>
            {/if}
          {/if}
        </div>

        <div class="survey-options">
          {#if $currentQuestion.type === TYPE_RADIO}
            <SingleChoice />
          {:else if $currentQuestion.type === TYPE_SELECT}
            <SearchableSelect />
          {:else if $currentQuestion.type === TYPE_CHECKBOX}
            <MultipleChoice />
          {:else if $currentQuestion.type === TYPE_NUMBER}
            <Number />
          {:else if $currentQuestion.type === TYPE_TEXTAREA}
            <TextArea />
          {:else if $currentQuestion.type === TYPE_VIZ}
            <Viz />
          {/if}
        </div>

        <div class="buttons-bar">
          <button class="chi-siamo" on:click={showAboutModal}>Chi siamo</button>

          <div class="progress-buttons">
            <BackButton />
            <ForwardButton />
          </div>
        </div>
      {/if}
    {/key}
  </section>
</div>

<style>
  h1 {
    font-size: 30px;
    margin: 0;
    padding: 2rem;
  }

  .portrait-bar {
    position: -webkit-sticky; /* Safari */
    position: sticky;
    top: 0;
    z-index: 2;
    width: 100vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .wrapper {
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .survey-banner {
    width: 100%;
    min-height: 40vh;
    background: url('../img/data_wall_mock.svg');
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
  }

  .survey-section {
    width: 100%;
    padding: 2rem;
  }

  .survey-section--start {
    padding: 0;
  }

  .subtext-wrapper {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  .subtext {
    margin-top: 0;
    margin-bottom: 2rem;
    color: #7d7c7c;
  }

  .multiple-choice-trackers {
    display: flex;
    gap: 0.3rem;
    margin-bottom: 2rem;
  }

  .multiple-choice-tracker {
    display: inline-block;
    width: 29px;
    height: 2px;
    background: rgba(255, 255, 255, 0.2);
  }

  .survey-options {
    max-width: 80vw;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    text-align: left;
    padding-bottom: 2rem;
  }

  .buttons-bar {
    background-color: #1f1f1f;
    width: 100vw;
    max-height: 60px;
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .progress-buttons {
    display: flex;
  }

  /* modal */
  .chi-siamo {
    color: inherit;
    border: none;
    font: inherit;
    cursor: pointer;
    outline: inherit;
    font-size: 12px;
    margin: 1rem;
    padding: 0.3rem 0.5rem;
    background-color: #2d2d2d;
    border-radius: 50px;
  }

  @media (min-width: 700px) {
    .survey-section {
      width: 800px;
    }

    .survey-section--start {
      width: 100%;
    }

    .survey-banner {
      width: 100%;
      background: url('../img/data_wall_mock_large.svg');
    }

    h1 {
      font-size: 38px;
      text-align: left;
      padding: 2rem 3rem;
    }
  }
</style>
